import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import { withRouter } from 'utils';
import { Typography, Tabs, Tab } from '@mui/material';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.primary.accent,
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  tabs: {
    paddingTop: 3,
    paddingLeft: theme.spacing(3),
  },
  indicator: {
    backgroundColor: '#FFFFFF',
    height: 2,
    marginBottom: 8,
  },
  headerDivider: {},
  tabPanel: {
    color: '#E0E0E0',
    '&.Mui-selected': {
      color: '#FFFFFF',
    },
    '&:hover': {
      color: '#FFFFFF',
    },
  },
});

class OrganizationsTabs extends React.Component {
  render() {
    const { tab, classes, user } = this.props;

    return (
      <div className={classes.container}>
        <title>Organizations</title>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>Organizations</Typography>
        </div>
        <Tabs
          variant='scrollable'
          TabIndicatorProps={{ className: classes.indicator }}
          className={classes.tabs}
          value={tab}
          onChange={this.onTabChange}
        >
          <Tab
            className={classes.tabPanel}
            label='All'
            value='organizations'
            disableRipple
          />
          <Tab
            className={classes.tabPanel}
            label='Favorites'
            value='favorite_organizations'
            disableRipple
          />
          <Tab
            className={classes.tabPanel}
            label='Recent'
            value='recent_organizations'
            disableRipple
          />
          <Tab
            className={classes.tabPanel}
            label='Affiliated'
            value='affiliated_organizations'
            disableRipple
          />
          <Tab
            className={classes.tabPanel}
            label='Patient Migration'
            value='patient_migration'
            disableRipple
          />

        </Tabs>
      </div>
    );
  }

  onTabChange = (event, newValue) => {
    this.props.router.navigate(`/${newValue}/`);
  };
}

OrganizationsTabs.propTypes = {
  router: PropTypes.object.isRequired,
  classes: PropTypes.object,
  tab: PropTypes.string.isRequired,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

const styled = withStyles(styles)(OrganizationsTabs);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as OrganizationsTabs };